export default "__VITE_ASSET__BfPrJgvk__"